export const CUSTOMER = "CUSTOMER";

export const ADD_CUSTOMER = "ADD_CUSTOMER";

export const LIST_CUSTOMER = "LIST_CUSTOMER";

export const CUSTOMER_DETAILS = "CUSTOMER_DETAILS";

export const CUSTOMER_DELETE = "CUSTOMER_DELETE";